<template>
  <div id="idverify_view_outer" v-if="judgeData != null">
    <div id="user_id_check_view">
      <div class="input-row">
        <div class="column left-label">*姓名：</div>
        <div class="column">{{judgeData.name}}</div>
      </div>
      <div class="input-row">
        <div class="column left-label">*证件号码：</div>
        <div class="column">{{judgeData.idNo}}</div>
      </div>
      <div style="text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">

        <div v-show="user != null && user.isIdentification > 0" style="height: 80px;line-height: 80px;">
          <span v-if="!isIdVerifiedError" style="color: green;"><span class="iconfont" style="margin-right:10px;font-weight: bold;">&#xe654;</span>实名认证已通过</span>
          <span v-else style="color:#fc1a34;"><span class="iconfont" style="margin-right:10px;">&#xe62b;</span>实名认证失败</span>
        </div>

        <el-button v-if="user != null && user.isIdentification > 0" class="next-button" @click="nextButtonClicked" round>下一步</el-button>
        <el-button v-else-if="!isIdVerifiedError" class="next-button" @click="realNameVerifyClicked" round>开始实名认证</el-button>
        <el-button v-else class="next-button" @click="realNameVerifyClicked" round>重新实名认证</el-button>
        <el-button class="cancel-button" @click="cancelButtonClicked" round>返回</el-button>
      </div>
    </div>

    <div v-if="false" id="user_passport_check_view">
      <div class="input-row">
        <div class="column left-label">*姓名：</div>
        <div class="column">{{judgeData.name}}</div>
      </div>
      <div class="input-row">
        <div class="column left-label">*证件号码：</div>
        <div class="column">{{judgeData.idNo}}</div>
      </div>


      <div class="input-row">
        <div class="column left-label">*上传证件照片:</div>
        <div class="column">
          <el-upload
            class="files-upload"
            action="https://api.shslqxh.com/upload/files"
            :headers="uploadHeaders"
            name="files"
            multiple
            :limit="fileLimit"
            :file-list="initialFileList"
            accept="image/png, image/jpg"
            list-type="picture-card"
            :on-exceed="handleExceed"
            :on-remove="handleFileRemove"
            :before-remove="beforeRemoveFile"
            :on-preview="handlePreview"
            :on-success="handleUploadSuccess"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">请上传护照信息页、有效签证及最近入境时间页</div>
          </el-upload>
        </div>
      </div>

      <div style="text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <el-button class="next-button" @click="postPostCardsClicked" round>下一步</el-button>
        <el-button v-if="judgeData.status != 8" class="cancel-button" @click="cancelButtonClicked" round>返回</el-button>
      </div>

      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageurl" alt="" />
      </el-dialog>

    </div>
  </div>
</template>

<script>
  import EventManager from "../../../js/event-common";

  var aliGetMetaInfo = getMetaInfo;
export default {
  name: "CertApplicationIDVerificationVue",
  props: {
    judge: {default: ()=> null}
  },
  data() {
    return {
      uploadHeaders: {},
      fileLimit: 5,
      initialFileList: [],
      fileList: [],
      dialogVisible: false,
      dialogImageurl: '',
      judgeData: null,
      passport: '',
      initPassport: '',
      isIdVerifiedError: false,
    }
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    isIdType() {
      if (this.judgeData == null) {
        return false;
      }
      let idType = this.judgeData.idType;
      return (idType == '二代身份证');
    },
    httpManager() {
      return this.$store.state.http;
    },
    eventManager() {
      return this.$store.state.eventManager;
    },
  },

  mounted() {
    this.judgeData = this.judge;
    let token = this.$store.state.dataStore.getToken();
    this.uploadHeaders.token = token;
    this.initWithUrl();
    this.initwithJudgeData();
    this.dealWithStatusChange();
    this.eventManager.postNotification(EventManager.notificationNameObject.UserUpdate, {});
  },
  methods: {
    valueChanged() {
      let isEdit = false;
      if (this.passport != this.initPassport) {
        isEdit = true;
      }
      let storedEditing = !this.$store.state.allowedLeave;
      if (storedEditing != isEdit) {
        this.$store.commit('isAllowedLeave', !isEdit);
      }
    },
    dealWithStatusChange() {
      let user = this.user;
      let _this = this;
      if (user == null) {
        setTimeout(function () {
          _this.dealWithStatusChange();
        }, 50);

        return;
      }
      let judgeData = this.judgeData;
      if (judgeData != null) {
        let status = judgeData.status;
        // let idType = judgeData.idType;
        if (status == 1) {
          if (user.isIdentification > 0) { // 已实名认证
            this.changeJudgeStatus(2, function(data) {
            }, function(data) {

            });
          }
        }
      }
    },

    initwithJudgeData() {
      let judgeData = this.judgeData;
      if (judgeData == null) {
        return;
      }

      let passport = judgeData.passport;
      if (passport != null && passport != '') {
        this.passport = passport;
        this.initPassport = passport;

        //... fileList
        let tmpArray = passport.split(",");
        for (let i = 0; i < tmpArray.length; i++) {
          let item = tmpArray[i];
          if (item != '') {
            let item = {
              name: 'passport_' + i,
              url: item,
            }
            this.fileList.push(item);
            this.initialFileList.push(item);
          }
        }

      }

    },
    initWithUrl() {
      let query = this.$route.query;
      let response = query.response;
      if (response != null) {
        let dataStr = decodeURI(response);
        response = JSON.parse(dataStr);
        let certifyId = response.extInfo.certifyId;
        let params = this.$route.params;
        let name = this.$route.name;
        this.$router.push({
          name,
          params,
          query: {}
        });
        this.updateRealNameState(certifyId);
      }
    },

    beforeRemoveFile(file, fileList) {
      return this.$confirm(`确定移除当前照片吗？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${ this.fileLimit } 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleFileRemove(file ,fileList) {
      let url = file.response;
      let index = this.fileList.findIndex(function (item) {
        return item.url == url;
      });
      this.fileList.splice(index, 1);
      if (this.fileList.length < this.fileLimit) {
        $("#idverify_view_outer .files-upload .el-upload--picture-card").show();
      }
      this.updatepassportPhotos();
    },
    handlePreview(file) {
      let url = file.response;
      this.dialogImageurl = url;
      this.dialogVisible = true;
    },
    handleUploadSuccess(res, file) {
      if (typeof res == 'string') {
        let name = file.name;
        let url = res;
        let obj = {
          name,
          url
        };
        this.fileList.push(obj);
        if (this.fileList.length >= this.fileLimit) {
         $("#idverify_view_outer .files-upload .el-upload--picture-card").hide();
        }
        this.updatepassportPhotos();
      }
    },

    updatepassportPhotos() {
      let fileList = this.fileList;
      let tmp = '';
      if (fileList.length > 0) {
        for (let i = 0; i < fileList.length; i++) {
          let image = fileList[i];
          tmp += image.url;
          if (i < fileList.length - 1) {
            tmp += ',';
          }
        }
      }
      this.passport = tmp;
      this.valueChanged();
    },

    realNameVerifyClicked() {
      let judgeData = this.judgeData;
      let metaInfo = aliGetMetaInfo();
      if (metaInfo == null) {
        return;
      }

      let metaInfoStr = JSON.stringify(metaInfo);
      let url = window.location.href;
      let params = {
        certName: judgeData.name,
        certNo: judgeData.idNo,
        metaInfo: metaInfoStr,
        returnUrl: encodeURI(url),
      };

      let _this = this;
      this.httpManager.ajax.postUserFaceVerifyInitData(params, function (data) {
        let code = data.code;
        if (code == 0) {
          let returnData = data.data;
          let certifyUrl = returnData.certifyUrl;
          let certifyId = returnData.certifyId;
          if (certifyUrl != null) {
            window.open(certifyUrl, '_self');
            return;
          }
          let errorMsg = '您的姓名与身份证号不匹配，请修改后重新提交。';
          _this.dealWithErrorMsg(errorMsg);
        } else {
          _this.$toast('请求失败');
        }
      }, function (data) {
        _this.$toast('请求失败，请重试');
      });
    },

    dealWithErrorMsg(errorMsg) {
      this.$toast(errorMsg);
      this.$store.commit('setIdErrorRemark', errorMsg);
    },

    updateRealNameState(certifyId) {
      let judgeData = this.judgeData;
      let params = {
        certifyId,
        name: judgeData.name,
        idNo: judgeData.idNo,
      };
      let _this = this;
      this.httpManager.ajax.getUserDescribeFaceVerifyData(params, function (data) {
        let code = data.code;
        _this.dealWithRealNameData(code);

      }, function (data) {
        _this.$toast('认证失败，请重试！');
      });
    },

    dealWithRealNameData(subCode) {
      if (subCode == 200 || subCode == 210) { // 认证成功;
        let user = this.user;
        user.isIdentification = 1;
        this.$store.commit("setUser", user);

        let _this = this;
        this.changeJudgeStatus(2, function (data) {
          let code = data.code;
          if (code == 0) {
            _this.isIdVerifiedError = false;
            _this.$toast('认证成功！');
            _this.$emit('realNameVerifySuccess');
            return;
          }
          _this.$toast('认证失败');
        }, function (data) {
          _this.$toast('认证失败，请重试！');
        });

        return
      } else {
        this.isIdVerifiedError = true;
        let errorMsg = '';
        switch (subCode) {
          case 201: // shenz
            errorMsg = "您的姓名与身份证号不匹配，请修改后重新提交。";
            break;
          case 202:
            errorMsg ="查询不到身份信息";
            break;
          case 203:
            errorMsg = "查询不到照片或照片不可用";
            break;
          case 204:
            errorMsg = "人脸比对不一致";
            break;
          case 205:
            errorMsg = "活体检测存在风险";
            break;
          default:
            errorMsg = "认证失败！";
        }
        this.dealWithErrorMsg(errorMsg);
      }
    },

    cancelButtonClicked() {
      this.$store.commit("isAllowedLeave", true);
      this.$emit("backToEditPage");
    },
    postPostCardsClicked() {
      let passport = this.passport;
      if (passport == '') {
        this.$toast('请上传证件照片！');
        return;
      }

      let judgeData = this.judgeData;
      let status = 3;
      if (judgeData.status == 8) {
        status = 4;
      }
      let params = {
        passport,
        id: judgeData.id,
        status
      };
      let _this = this;
      this.httpManager.ajax.postupdateJudgePassportData(params, function (data) {
        let code = data.code;
        if (code == 0) {
          //发送成功
          _this.$store.commit('isAllowedLeave', true);
          _this.$toast("信息提交成功！");
          setTimeout(function () {
            _this.$emit("nextStepClick");
          }, 500);
          return;
        }
        _this.$toast("信息提交失败！");
      }, function (data) {
        _this.$toast("信息提交失败，请重试！");
      });
    },

    changeJudgeStatus(status, success, failure) {
      let id = this.judgeData.id;
      let params = {
        status: status,
        auditStatus: 1,
        id,
      };
      this.httpManager.ajax.updateJudgeStatusData(params, success, failure);
    },

    nextButtonClicked() {
      let _this = this;
      this.changeJudgeStatus(3, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.$emit("nextStepClick");
          return;
        }
        _this.$toast('请求失败');
      }, function (data) {
        _this.$toast('请求失败，请重试');
      });
    }
  }
}
</script>

<style scoped>
  #idverify_view_outer {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
  }

  #idverify_view_outer > div {
    width: 100%;
    margin-top: 30px;
  }

  #idverify_view_outer .input-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 15px;
  }

  #idverify_view_outer .input-row:last-child {
    margin-bottom: 0;
  }

  #idverify_view_outer .input-row > .column:first-child {
    width: 50%;
    text-align: right;
    padding-right: 10px;
  }

  #idverify_view_outer .input-row > .column:not(:first-child) {
    width: 50%;
    padding-left: 10px;
  }

  #idverify_view_outer #user_passport_check_view .input-row > .column:first-child {
    width: 30%;
  }

  #idverify_view_outer #user_passport_check_view .input-row > .column:not(:first-child) {
    width: 70%;
  }


  #idverify_view_outer .left-label {
    font-size: small;
  }

  #idverify_view_outer .next-button {
    background-color: #fc1a34;
    border-color: #fc1a34;
    width: 90%;
    max-width: 300px;
    padding-left: 0;
    padding-right: 0;
    color: white;
    margin-top: 40px;
    margin-bottom: 15px;
  }

  #idverify_view_outer .cancel-button {
    width: 90%;
    max-width: 300px;
    margin-bottom: 20px;
    border-color: lightgrey;
    background-color: white;
    color: #666;
  }


  .files-upload {
    margin-top: 15px;
    text-align: left;
  }

  #idverify_view_outer .files-upload /deep/ .el-upload-list__item, #idverify_view_outer .files-upload /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }
  #idverify_view_outer .files-upload /deep/ .el-upload--picture-card {
    line-height: 100px;
  }

  #idverify_view_outer .files-upload /deep/ input[type='file'] {
    display: none;
  }

  #idverify_view_outer .files-upload /deep/ .el-button {
    background-color: #fc1a34;
    color: white;
    border: none;
    margin-top: 10px;
  }


  #idverify_view_outer .files-upload /deep/ .el-upload__tip {
    margin-top: 15px;
  }

  @media screen and (min-width: 768px){
    #idverify_view_outer > div {
      max-width: 700px;
    }

    #idverify_view_outer .left-label {
      font-size: 1rem;
    }

    #idverify_view_outer .files-upload /deep/ .el-upload-list__item, #idverify_view_outer .files-upload /deep/ .el-upload--picture-card {
      width: 140px;
      height: 140px;
    }

    #idverify_view_outer .files-upload /deep/ .el-upload--picture-card {
      line-height: 140px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/certificates/application/CertApplicationIDVerificationVue.vue